import React, {Component} from 'react'
import PropTypes from 'prop-types'

import '../../styles/css/ProgressButton.css'


const propTypes = {
    backColor: PropTypes.string,
    progressColor: PropTypes.string,
    textColor: PropTypes.string,
    title: PropTypes.string.isRequired,
    progress: PropTypes.number,
    screen: PropTypes.number,
}

const defaultProps = {
    backColor: '#000',
    progressColor: '#cc172c',
    textColor: 'white',
}


class ProgressButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentDidMount() {

    }

    render() {
      // let container = document.getElementById('progress-button-container')
      // var progressWidth = '100'
      var answer2TextSize = '40px'
      var answerTextSize = '40px'
      if(this.props.variables.answersize && this.props.variables.answersize.trim().length > 0){
        answerTextSize = this.props.variables.answersize + "px"
      }
      if(this.props.screen === 4){
        if(this.props.variables.answersize4 && this.props.variables.answersize4.trim().length > 0){
          answerTextSize = this.props.variables.answersize4 + "px"
        }
      }
      // if(this.props.variables.answersize && this.props.variables.answersize.trim().length > 0){
      //   answer1TextSize = this.props.variables.answersize + "px"
      // }

      // if(container){
      //     progressWidth = parseInt(container.clientWidth * this.props.progress / 100, 10)
      // }

        return (
            <div className="progress-button-container" id="progress-button-container" style={{
              backgroundColor: this.props.correct ? this.props.variables.progressBarEndWinColor : this.props.variables.progressBarBackgroundColor
            }}>
                <div className="progress-container" style={{
                    backgroundColor: this.props.variables.progressBarColor,
                    // width: progressWidth,
                }} />

                <div className="progress-title-container" style={{display: 'block', alignItems: 'center'}}>
                    <p className="progress-title" style={{ color: this.props.variables.progressBarTextColor, fontSize: answerTextSize }}>{this.props.title}</p>
                  {/*  <p className="progress-value" style={{ color: this.props.variables.progressBarTextColor }}>{parseInt(this.props.progress, 10)}%</p>*/}
                </div>
            </div>
        )
    }
}

ProgressButton.propTypes = propTypes
ProgressButton.defaultProps = defaultProps

export default ProgressButton



// WEBPACK FOOTER //
// ./src/components/utils/ProgressButton.js